"use client";

import { useState } from "react";
import { ChatSuggestionBox } from "../input/ChatSuggestionBox";
import { useTenant } from "../../../contexts/TenantContext";

interface WelcomeScreenProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
}

export function WelcomeScreen({ onSendMessage, disabled = false }: WelcomeScreenProps) {
  const { config } = useTenant();
  const categories = config.categories;

  // Default to the second category ("my condition") when present, else the first.
  const defaultCategoryId = (categories[1] ?? categories[0]).id;
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>(defaultCategoryId);

  const selectedCategory =
    categories.find((c) => c.id === selectedCategoryId) ?? categories[0];

  return (
    <div className="flex flex-col h-full items-center justify-center min-h-[calc(100vh-240px)]">
      {/* Welcome Header Section */}
      <div className="text-center mb-8">
        <img
          src={config.logo}
          alt={config.displayName}
          className="mx-auto h-24 w-24 animate-float mb-6 drop-shadow-xl"
          style={{
            objectFit: "contain",
          }}
        />
        <h2 className="text-4xl font-bold text-primary-600">
          Wie kann ich Ihnen helfen?
        </h2>
      </div>

      {/* Category Buttons */}
      <div className="flex flex-wrap justify-center gap-3 mb-8 min-h-[52px]">
        {categories.map((category) => {
          const Icon = category.icon;
          return (
            <button
              key={category.id}
              onClick={() => setSelectedCategoryId(category.id)}
              className={`
                min-w-[180px] px-6 py-3 rounded-xl font-medium transition-all duration-200
                flex items-center justify-center gap-2 border
                ${
                  selectedCategoryId === category.id
                    ? "bg-primary-600 text-white border-primary-600 shadow-lg hover:bg-primary-700"
                    : "bg-[#FFFFFF] text-foreground border-border hover:border-primary-300 hover:bg-primary-50/50 "
                }
              `}
            >
              <Icon className="h-5 w-5" />
              <span>{category.label}</span>
            </button>
          );
        })}
      </div>

      {/* Suggestion List Section */}
      <ChatSuggestionBox
        suggestions={selectedCategory.suggestions}
        onSendMessage={onSendMessage}
        category={selectedCategory.id}
        disabled={disabled}
      />
    </div>
  );
}
